import React from "react";
import { Link, useParams } from "react-router-dom";
import Accordion from "../components/common/Accordion";
import Breadcrumbs from "../components/common/Breadcrumbs";
import EmptyState from "../components/common/EmptyState";
import PageMeta from "../components/common/PageMeta";
import { getContentPage } from "../data/contentPages";

const PolicyLinks = ({ links = [] }) => (
  <ul>
    {links.map((link) => (
      <li key={`${link.label}-${link.href}`}>
        {link.href.startsWith("/") ? (
          <Link to={link.href}>{link.label}</Link>
        ) : (
          <a href={link.href}>{link.label}</a>
        )}
      </li>
    ))}
  </ul>
);

const StaticPage = ({ slug: suppliedSlug }) => {
  const params = useParams();
  const slug = suppliedSlug || params.slug;
  const page = getContentPage(slug);
  if (!page) return <EmptyState title="Page not found" description="We could not find that information page." actionLabel="Return home" actionTo="/" />;

  return (
    <article className="static-page">
      <PageMeta title={page.title} description={page.intro} />
      <header className="static-page__hero"><div className="site-container"><Breadcrumbs items={[{ label: "Home", href: "/" }, { label: page.title }]} /><p className="eyebrow">{page.eyebrow}</p><h1>{page.title}</h1><p>{page.intro}</p>{page.updatedAt && <small>Last updated {page.updatedAt}</small>}</div></header>
      <div className="site-container static-page__body">
        {page.groups ? page.groups.map((group) => <section className="static-page__faq-group" key={group.title}><h2>{group.title}</h2>{group.items.map((item) => <Accordion title={item.question} key={item.question}><p>{item.answer}</p></Accordion>)}</section>) : page.sections?.map((section) => <section id={section.id} key={section.id}><h2>{section.title}</h2>{section.body?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}{section.items && <dl>{section.items.map((item) => <div key={item.label}><dt>{item.label}</dt><dd>{item.value}</dd></div>)}</dl>}{section.highlights && <ul>{section.highlights.map((item) => <li key={item}>{item}</li>)}</ul>}{section.links && <PolicyLinks links={section.links} />}</section>)}
      </div>
    </article>
  );
};

export default StaticPage;
